import React, { Component } from "react";
import { Navbar, NavbarBrand } from "reactstrap";

class AssociationsNavBar extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div id="navbar">
        <Navbar color="faded" light expand="md">
          <NavbarBrand href="http://metz.fr">
            <span style={{ fontSize: "24px", color: "white" }}>metz.fr</span>
          </NavbarBrand>
        </Navbar>
      </div>
    );
  }
}

export default AssociationsNavBar;
